module.exports = __webpack_public_path__ + "img/blue_060.ce423e39.png";